import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import { Button, Spin } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
//import WrapAction from '../../Inquiry/components/wrap-action';
import inventoryService from '@root/modules/Warehouse/Inventory/service/inventory';
import WrapActionInven from './wrap-action/WrapActionInven';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface DataInvenWare {
  key: React.Key;
  sellerName: string;
  sellerEmail: string;
  numberPro: number;
  updatedDate: string;
  param: number;
}

/*-----------------------------------*/
const TableInventory = () => {
  const [listExcel, setListExcel] = useState([] as any);
  const history = useHistory();
  const [sort, setSort] = useState(true);
  const [idInven, setIdInven, listInventory, setListInventory] =
    useContext<any>(ProductContext);
  const [filter, setFilter] = useState([] as any);
  const [query, setQuery] = useState();
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const [totalPages, setTotalPages] = useState(1);
  const [searchBy, setSearchBy] = useState('');
  const [labelSelect, setLabelSelect] = useState({
    key: '1',
    label: 'Select'
  } as any);
  const [listData, setListData] = useState([] as any);
  const [valueSearch, setValueSearch] = useState('');
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [page, setPage] = useState(1);
  const debounc = useDebounce(valueSearch, 1000);
  const [loading, setLoading] = useState(false);

  const [isSearch, setIsSearch] = useState('');

  const columns: ColumnsType<DataInvenWare> = [
    {
      title: 'No',
      dataIndex: 'key'
      // render: (text, record, index) => index + 1
    },
    {
      title: 'Seller name',
      dataIndex: 'name'
    },
    {
      title: 'Seller email address',
      dataIndex: 'email'
    },

    {
      title: 'Number of product types',
      dataIndex: 'numberOfProductType'
    },

    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(true);
                setPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(false);
                setPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  /*----------------------------checkbox---------------------*/
  const rowSelectionn = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataInvenWare[]) => {
      setListExcel(selectedRows);
    },
    getCheckboxProps: (record: DataInvenWare) => ({
      disabled: record.sellerName === 'Disabled User',
      name: record.sellerName
    })
  };

  /*----------------------excel---------------------------------*/

  const idMap = listExcel.map((item: any) => item.key);

  const arrId = {
    ids: idMap
  };

  const handleOnExport = async () => {
    if (listExcel.length === 0) {
      const response = await inventoryService.postDownExcelSell(
        fromDt,
        toDt,
        searchBy,
        valueSearch,
        sort
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inventory ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await inventoryService.postDownExcelSellId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inventory_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  /*-------------------------------paging---------------------------------*/

  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabelSelect({ key: e.key, label: e.domEvent.target.innerText });
  };
  const handelPagination = async (
    page: number,
    fromDt: string,
    toDt: string,
    searchBy: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const res = await inventoryService.getListSeller(
      page,
      fromDt,
      toDt,
      searchBy,
      filter,
      filterInput,
      sort
    );
    setTotalPages(res.count);
    const rowData = res.data?.map((row: any) => {
      return {
        ...row,
        key: row.id,
        param: row.sellerId,
        updatedAt: formatDateTime(row.updatedAt)
      };
    });

    setListInventory(rowData);
    setLoading(false);
  };

  useEffect(() => {
    if (!!valueSearch && !!setSearchBy) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
      setPage(1);
    }
  }, [debounc, setSearchBy]);

  useEffect(() => {
    handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
    setPage(1);
  }, [isSearch, fromDt, toDt, sort, searchBy]);

  /*-----------------------------search-----------------------------------*/

  const onChangeSearch = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDateValue = (value: [string, string]) => {
    setFilterDate(value);
    setPage(1);
  };

  // const SearchName = () => {
  //   handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
  //   setPage(1);
  // };

  return (
    <Spin spinning={loading} className="loading-forgot">
      <WrapActionInven
        WrapAction
        getSelect={getSelect}
        labelSelect={labelSelect}
        typeDrop="sell"
        onChangeSearch={onChangeSearch}
        getDateValue={getDateValue}
        // onSearchName={SearchName}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '15px 17px',
          background: 'white',
          alignItems: 'center'
        }}
      >
        <div>
          <span style={{ marginLeft: '8px', marginRight: '8px' }}>
            Total Seller {totalPages}
          </span>
          <div
            className="ant-divider ant-divider-vertical"
            role="separator"
          ></div>
          {listExcel.length !== 0 ? (
            <span style={{ marginLeft: 8 }}>
              Select Seller {listExcel?.length}
            </span>
          ) : (
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Select Seller 00
            </span>
          )}
        </div>

        <div>
          <Button className="downExcel" onClick={handleOnExport}>
            Download Excel
          </Button>
        </div>
      </div>

      <Table
        className="warehouse-table"
        columns={columns}
        dataSource={listInventory}
        rowSelection={rowSelectionn}
        pagination={{
          pageSize: 10,
          current: page,
          total: totalPages,
          onChange: (page, limit) => {
            setPage(page);

            handelPagination(page, searchBy, valueSearch, fromDt, toDt, sort);
          }
        }}
        onRow={(item) => {
          return {
            onClick: () => {
              history.push(`/admin/inventory/${item.key}`);
            }
          };
        }}
      />
    </Spin>
  );
};

export default TableInventory;
